import React from 'react';
import teleoptikImage from '../../images/presentations/presentation_teleoptik.png';
import reljaImage from '../../images/presentations/presentation_relja.png';
import konelekImage from '../../images/presentations/presentation_konelek.png';
import downArrow from '../../images/icons/down-arrow.svg';
import atiImage from '../../images/presentations/presentation_ati.png';

const PresentationComponent = ({ fileName, title, imagePath }) => (
  <div style={{ width: '24%' }}>
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={`/files/inovation-pool/${fileName}.pdf`}
    >
      <div style={{ height: '350px' }}>
        <img
          style={{ width: '100%', height: '80%' }}
          src={imagePath}
          alt="presentation"
        />
        <h5 className="mt-3">{title}</h5>
      </div>
    </a>
    <a
      style={{ fontSize: '1.5rem' }}
      href={`/files/inovation-pool/${fileName}.pdf`}
      download
    >
      Preuzmi
      <img
        style={{ width: '20px', height: '20px', marginLeft: '5px' }}
        src={downArrow}
        alt="download"
      />
    </a>
  </div>
);

const InovationPoolPage = () => {
  return (
    <div className="center-container" style={{ padding: '20px 0' }}>
      <h3>Innovative model to support innovation development in SMEs</h3>

      <div
        style={{ padding: '20px 0' }}
        className="d-flex flex-wrap justify-content-between "
      >
        <PresentationComponent
          fileName="Prezentation_Teleoptik_p"
          title="TELEOPTIK gas equipment, Zemun - Serbia"
          imagePath={teleoptikImage}
        />

        <PresentationComponent
          fileName="Prezentation_ReljaJR_p"
          title="RELJA JR, Zrenjanin Serbia"
          imagePath={reljaImage}
        />

        <PresentationComponent
          fileName="Prezentation_Konelek_p"
          title="KONALEK, Batajnica Serbia"
          imagePath={konelekImage}
        />
        <PresentationComponent
          fileName="Prezentation_Atiterming_p"
          title="ATI TERMING, Kula Serbia"
          imagePath={atiImage}
        />
      </div>
    </div>
  );
};

export default InovationPoolPage;
